import React from "react";
import useAuthenticatedFetch from "./common/useAuthenticatedFetch";
import { ApiResponse } from "./models/ApiResponse";
import { GetMeResponse } from "./models/Me";
import { getInitialsFromDisplayName } from "../utils/getInitialsFromDisplayNames";

const useMe = () => {
    const { response, isLoading } =
        useAuthenticatedFetch<ApiResponse<GetMeResponse>>("api/me");

    return {
        me: response?.content,
        isLoading,
    };
};

export type MeContextType = {
    displayName?: string;
    emailAddress?: string;
    initials: string;
    isLoading: boolean;
};

const MeContext = React.createContext<MeContextType>({
    displayName: undefined,
    emailAddress: undefined,
    initials: "",
    isLoading: true,
});

export const useMeContext: () => MeContextType = () =>
    React.useContext(MeContext);

export type MeContextProviderProps = {
    children: React.ReactNode;
};

export const MeContextProvider = ({ children }: MeContextProviderProps) => {
    const { me, isLoading } = useMe();

    return (
        <MeContext.Provider
            value={{
                displayName: me?.displayName,
                emailAddress: me?.emailAddress,
                initials: getInitialsFromDisplayName(me?.displayName),
                isLoading,
            }}
        >
            {children}
        </MeContext.Provider>
    );
};
